module.exports = __webpack_public_path__ + "cc6e9c8e2be1db005572edf6d2843fa5.png";